import { Routes, Route } from "react-router-dom";
import LocalTransportRuleCreateScreen from "screens/App/CRM/LocalTransportRule/LocalTransportRuleCreateScreen";
import LocalTransportRuleDetailScreen from "screens/App/CRM/LocalTransportRule/LocalTransportRuleDetailScreen";
import LocalTransportRuleEditScreen from "screens/App/CRM/LocalTransportRule/LocalTransportRuleEditScreen";
import LocalTransportRuleListScreen from "screens/App/CRM/LocalTransportRule/LocalTransportRuleListScreen";

import { NotFoundScreen } from "screens/NotFoundScreen";

const LocalTransportRuleRouter = () => {
  return (
    <Routes>
      <Route path="list" element={<LocalTransportRuleListScreen />} />
      <Route path="create" element={<LocalTransportRuleCreateScreen />} />
      <Route path=":id/detail" element={<LocalTransportRuleDetailScreen />} />
      <Route path=":id/edit" element={<LocalTransportRuleEditScreen />} />
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default LocalTransportRuleRouter;
